"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var normalizeBoolean = function normalizeBoolean(value) {
  if (value === 'true' || value === 'yes') {
    return true;
  }

  if (value === 'false' || value === 'no') {
    return false;
  }

  return value;
};

var normalizeCheckbox = function normalizeCheckbox(value) {
  if (value === false || value === 'false') {
    return undefined;
  }

  return value;
};

var normalizeNumber = function normalizeNumber(value) {
  if (!value) {
    return undefined;
  }

  return value.replace(/[^\d]/g, '');
}; // eslint-disable-next-line import/no-anonymous-default-export


var _default = function _default(normalize) {
  if (normalize === 'boolean') {
    return normalizeBoolean;
  }

  if (normalize === 'checkbox') {
    return normalizeCheckbox;
  }

  if (normalize === 'number') {
    return normalizeNumber;
  }

  return undefined;
};

exports["default"] = _default;